import { theme } from '@prophecy/theme';
import { Stack, Switch } from '@prophecy/ui-v3';

export default function Priviliges() {
  return (
    <Stack height='100%'>
      <Stack direction='horizontal' gap={theme.spaces.x40}>
        <Switch data-test-id='privileges-publish-switch'>Publish</Switch>
        <p>
          Publishing a dataset allows you to share it outside of your project. This way, other teams within an
          organization can read or modify this dataset through Prophecy. Please note that these settings do not control
          access to physical data within your file stores and tables. Those you can set directly through your execution
          environment.
        </p>
      </Stack>
    </Stack>
  );
}
